<template>
  <div class="card shadow m-3 position-fixed right-0 top-0" style="z-index: 1" data-test="progress-bar">
    <div style="width: 456px" class="card-body d-flex align-items-center">
      <div
        :class="{ rotate: !errorListStatus }"
        class="mr-3 rounded-round d-flex align-items-center justify-content-center p-2 border-2 border-primary text-primary"
        style="width: 50px; height: 50px"
      >
        <i class="fa-solid fa-hourglass-half fa-2x" />
      </div>

      <div style="width: 80%">
        <div class="progress rounded-round mb-2" style="height: 12px">
          <div
            class="progress-bar bg-primary rounded-round"
            :style="`width:${progressBarWidth}%;`"
          />
        </div>
        <div data-test="text-progress-creating-inventory-list">{{ $t("Creating Inventory List") }}...</div>
      </div>
      <button
        :class="{ 'text-muted': !isClose }"
        @click="close()"
        type="button"
        class="close align-self-start ml-2 mr-n1 mt-n2"
      >
        <span>×</span>
      </button>
    </div>
    <div v-if="showLogError" class="mb-2 mt-lg-n2 mx-3">
      <a
        href="#collapse-icon"
        class="collapsed font-size-sm text-default"
        data-toggle="collapse"
      >
        <span class="dropdown-toggle text-primary-400 text-underline">
          {{ $t("_Inventory.Response Message") }}
        </span>
      </a>
    </div>
    <div v-if="showLogError">
      <div class="collapse" id="collapse-icon">
        <div
          v-if="errorListStatus"
          class="card-body border-left-warning border-left-2 pl-0 pt-0"
          style="max-height: 600px; overflow-x: hidden; overflow-y: auto;"
        >
          <ul class="list mb-0">
            <div
              v-for="(list, i) in errorList"
              :key="'list' + i"
              :class="
                i == errorList.length - 1
                  ? 'font-size-sm mb-2'
                  : 'font-size-sm mb-2 border-bottom'
              "
            >
              <div v-if="list.status" class="line-height-1 row">
                <div class="col-12">
                  <p class="text-success">
                    {{ $t("Product") }}: {{ list.productName }},
                  </p>
                  <p class="text-success">
                    {{ $t("Available QTY") }}: {{ list.qty }}
                  </p>
                </div>
              </div>
              <div v-else class="line-height-1 row">
                <div class="col-12">
                  <p class="text-danger">
                    {{ $t("Product") }}: {{ list.productName }},
                  </p>
                  <p class="text-danger">
                    {{ $t("Message") }}: {{ list.message }},
                  </p>
                  <p class="text-danger">
                    {{ $t("Available QTY") }}: {{ list.qty }}
                  </p>
                </div>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Echo from "laravel-echo";
window.Pusher = require("pusher-js");
import WebSocket from "isomorphic-ws";

export default {
  data() {
    return {
      progressBarWidth: 0,
      showLogError: false,
      errorListStatus: false,
      isClose: false,
      tenant: JSON.parse(Cookies.get("tenant")),
      user: JSON.parse(Cookies.get("user")),
      websocket: null,
      errorList: [],
      errorListCheck: new Set()
    };
  },
  methods: {
    close() {
      this.leaveChannel();
      this.$store.dispatch("inventory/isProgressBarInventory", false);
      this.$store.dispatch("inventory/refreshAlertRestock", true);
    },
    leaveChannel() {
      const tenant = this.tenant;
      const user = this.user;
      // window.Echo.leaveChannel(`inventories.create.${user.id}${tenant.id}`);
      if (!localStorage.getItem('isCypress')) {
        if (this.websocket) {
          // console.log('Off websocket')
          this.websocket.close();
        }
      }
    },
    
    openChannel() {
      const tenant = this.tenant;
      const user = this.user;
      const vm = this;
      if (localStorage.getItem('isCypress')) {
        let dataWebsocket = JSON.parse(localStorage.getItem('cypressDataWebsocket'));
          if (dataWebsocket) {
            dataWebsocket.forEach(data => {
              let dataOnmessage = JSON.parse(JSON.stringify(data)) 
              vm.websocketOnMessage(dataOnmessage ,user, tenant);
            }); 
          }
      } else {
        if (
        this.$storeIndex.isset(() => tenant.id) &&
        this.$storeIndex.isset(() => user.id)
      ) {
        let ws = (this.websocket = new WebSocket(
          process.env.WEBSOCKETS_GOQUEUE_URL
        ));
        // Open websocket
        ws.onopen = function open() {
          console.log("onopen");
          let clientUid = `inventories.create.${user.id}${tenant.id}`;

          ws.send(
            JSON.stringify({
              data: {
                clientUid: clientUid
              },
              event: "subscribe"
            })
          );
        };
        // Action websocket

        ws.onmessage = function incoming(message) {
          let dataOnmessage = JSON.parse(message.data);
          vm.websocketOnMessage(dataOnmessage , user ,tenant);
        };
      }
    }
    },
  
    websocketOnMessage (data , user ,tenant) {
      let vm = this;
      var typeProductMsg = vm.$store.state.inventory.listDataProgressBar.type ? vm.$store.state.inventory.listDataProgressBar.type : '';
      let textAlert = (typeProductMsg == "view_product_create") ? "Create Inventory Success." : "Create Inventory List Success.";
      vm.errorList = [];
      var productList = [];
      var product = this.$store.state.inventory.listDataProgressBar.products;
      product.forEach(el => {
        if (el.product_id == data.data.productId){
          el.status = true
        }
      });

      let count_product_all = product.filter(el => el.status == true).length;

      if (
            data.data.clientUid ==
              `inventories.create.${user.id}${tenant.id}` &&
            data.event == `inventories.create`
          ) {
            let payload = data.data;
            // productList = productList.filter(id => {
            //   return id != payload.productId;
            // });
            // if (data.data.queueEvents == "STOCK_CREATE") {
            //   let count_product = count_product_all - productList.length;
            //   var progress = (count_product / count_product_all) * 100;
              var progress = 0
              progress = (count_product_all / product.length) * 100;
              vm.progressBarWidth = progress;
            

            let productDetail = product.find(
              p => p.product_id == payload.productId
            );
            if (payload.productId) {
              if (!payload.status) {
                if (!vm.showLogError) {
                  vm.showLogError = true;
                }
                if (!vm.errorListCheck) {
                  vm.errorListCheck = new Set();
                }

                let existingIndex = vm.errorList.findIndex(
                  item => item.productId === payload.productId
                );
                if (existingIndex !== -1) {
                  vm.errorList[existingIndex] = {
                    status: payload.status,
                    productId: payload.productId,
                    productName: productDetail.product_name || "",
                    qty: productDetail.warehouses[0].quantity,
                    message: vm.$t(payload.message.split('"').join(""))
                  };
                } else {
                  vm.errorListCheck.add(payload.productId);
                  vm.errorList.unshift({
                    status: payload.status,
                    productId: payload.productId,
                    productName: productDetail.product_name || "",
                    qty: productDetail.warehouses[0].quantity,
                    message: vm.$t(payload.message.split('"').join(""))
                  });
                }
              } else {
                let existingIndex = vm.errorList.findIndex(
                  item => item.productId === payload.productId
                );
                if (existingIndex !== -1) {
                  vm.errorList[existingIndex] = {
                    status: payload.status,
                    productId: payload.productId,
                    productName: productDetail.product_name || "",
                    qty: productDetail.warehouses[0].quantity
                  };
                } else {
                  vm.errorListCheck.add(payload.productId);
                  vm.errorList.unshift({
                    status: payload.status,
                    productId: payload.productId,
                    productName: productDetail.product_name || "",
                    qty: productDetail.warehouses[0].quantity
                  });
                }
              }
            }

            if (progress == 100) {
              vm.$forceUpdate();
              let errorItemsWithFalseStatus = vm.errorList.filter(
                item => item.status === false
              );
              if (errorItemsWithFalseStatus.length > 0) {
                vm.showLogError = true;
              } else {
                vm.showLogError = false;
              }
              vm.errorListStatus = true;
              if (!vm.showLogError) {
                setTimeout(() => {
                  vm.close();
                }, 1000);

                setTimeout(() => {
                  vm.$toastr.s(
                    vm.$t(textAlert),
                    "<span class='t-icon icon-checkmark3'></span>" +
                      vm.$t("Success")
                  );
                  vm.$store.dispatch("inventory/refreshAlertRestock", true);
                }, 1000);
              }
            }
          }
  },
},
  mounted() {
      this.openChannel();
    // const thisVue = this;
    // window.Echo.connector.pusher.connection.bind('state_change', function(states) {
    //   const unavailableStates = ["unavailable", "disconnected"];
    //   if (unavailableStates.includes(states.current)) {
    //     thisVue.close();
    //   }
    // });
  },
  beforeDestroy() {
    this.close();
  },
  watch: {}
};
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/components/tenancy/admin/inventory/inventoryList/ProgressBarInventory.vue